import coverVilla from '../assets/property-covers/villa.jpg';
import coverVillaProject from '../assets/property-covers/villa-project.jpg';
import coverShop from '../assets/property-covers/shop.jpg';
import coverLand from '../assets/property-covers/land.jpg';

/** Inline SVG fallbacks for types without a photo asset */
const svgCover = (label, color1, color2, glyph) =>
  `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="450" viewBox="0 0 800 450">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${color1}"/>
          <stop offset="100%" stop-color="${color2}"/>
        </linearGradient>
      </defs>
      <rect width="800" height="450" fill="url(#g)"/>
      <text x="400" y="210" text-anchor="middle" font-size="72" fill="rgba(255,255,255,0.92)">${glyph}</text>
      <text x="400" y="280" text-anchor="middle" font-family="system-ui,sans-serif" font-size="28" fill="rgba(255,255,255,0.85)">${label}</text>
    </svg>`
  )}`;

const DEFAULT_COVERS = {
  villa: coverVilla,
  apartment: svgCover('Apartment', '#1e3a5f', '#3b82f6', '🏢'),
  shop: coverShop,
  showroom: coverShop,
  office: svgCover('Office', '#0f172a', '#475569', '💼'),
  warehouse: svgCover('Warehouse', '#422006', '#a16207', '🏭'),
  land: coverLand,
  residential: coverVilla,
  commercial: coverShop,
  mixed: svgCover('Mixed use', '#312e81', '#6366f1', '🏙️'),
  project: coverVillaProject,
};

/**
 * Resolve cover image: uploaded/main URL first, else type default.
 */
export function resolveCoverImage(opts = {}) {
  const custom = opts.coverImageUrl || opts.cover_image_url;
  if (custom && String(custom).trim()) return String(custom).trim();

  const raw = (
    opts.unitType ||
    opts.primaryUnitType ||
    opts.type ||
    opts.propertyType ||
    opts.projectType ||
    'residential'
  );
  const key = String(raw || 'residential').toLowerCase().trim();
  return DEFAULT_COVERS[key] || DEFAULT_COVERS.residential;
}

export function getDefaultCoverForType(type) {
  return resolveCoverImage({ type });
}
